import industry_1 from "../../Img/Mobile_Device_Management_image/industry_1.svg";
import industry_2 from "../../Img/Mobile_Device_Management_image/industry_2.svg";
import industry_3 from "../../Img/Mobile_Device_Management_image/industry_3.svg";
import industry_4 from "../../Img/Mobile_Device_Management_image/industry_4.svg";
import section_img_1 from "../../Img/Mobile_Device_Management_image/section_img_1.jpg";
import number_1 from "../../Img/Mobile_Device_Management_image/number_1.png";
import number_2 from "../../Img/Mobile_Device_Management_image/number_2.png";
import number_3 from "../../Img/Mobile_Device_Management_image/number_3.png";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";

import "./Deployment_Management.css";
const Deployment_Management = () => {
  return (
    <>
      <Navbar></Navbar>
      <section class="banner_section elementor-column-gap-extended">
        <div class="container">
          <h1 class="elementor-heading-title">
            Device Deployment &amp; Management
          </h1>
          <div class="dropdown-str">
            <a class="dropbtn-str" href="/ContactUs" target="_blank">
              Contact Us
            </a>
          </div>
        </div>
      </section>
      {/* ------------------------------------------------------- */}
      <section class="mt-5">
        <div class="container">
          <div class="row g-4">
            <div class="col-12">
              <div class="best-in-class">
                <h1>
                  Creating streamlined operations with best-in-class solutions
                </h1>
                <p>
                  There is a growing need to have a central and streamlined
                  process to manage, deploy and administer devices across
                  various organizations without the need of constant IT
                  intervention. However, organizations often find it challenging
                  to align the available resources as the team multiplies and
                  the business grows. They need to model their deployment and
                  device management strategy in a way that saves both time and
                  money.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------------------------------------------------- */}
      <section class="py-5 text-center mt-4">
        <div class="container">
          <h2 class="section-title pb-3">Industry pain points</h2>
          <p>
            If you are facing the following problems, then it’s time to revamp
            your Deployment and Management infrastructure.
          </p>
          <div class="row mt-5 ">
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_1} alt="" className="img-fliud" />
                <p>
                  You are unable to figure out a roadmap for deploying devices
                  across locations.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_2} alt="" className="img-fliud" />
                <p>
                  Your IT team finds it difficult to track and manage
                  devices/assets across locations.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_3} alt="" className="img-fliud" />
                <p>
                  You find it difficult to manage corporate policies across
                  devices in your organization.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_4} alt="" className="img-fliud" />
                <p>
                  You are unable to track devices and distribute the right
                  applications/software relevant to different teams.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ----------------------------------------- */}
      <section class="custom-section">
        <div class="container">
          <div class="row align-items-center g-4">
            {/* Text  */}
            <div class="col-lg-6">
              <p class="highlight">How mdm can help​</p>
              <h2 class="main-title">Innovation-led solutions</h2>
              <p class="description">
                mdm’s Mobile Device Management (MDM) solutions have a proven
                record of efficient services as well as after-service training
                that helps organizations transition seamlessly. mdm’s expertise
                and robust infrastructure to help organizations identify the
                right solution for their requirement allows them to reap the
                benefits and build an MDM strategy that is beneficial and
                hassle-free.
              </p>
            </div>
            {/* Image  */}
            <div class="col-lg-6 position-relative">
              <div class="image-box">
                <img src={section_img_1} alt="" className="img-fliud" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ------------------------------------------------ */}
      <section class="why-section mt-4">
        <div class="container">
          <h2 class="why-title">Our Process</h2>
          <div class="row why-overlay mx-auto mt-5 g-4">
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="Our_Process">
                <div class="why-icon">
                  <img src={number_1} alt="" className="img-fliud" />
                </div>
                <h5>Discover and Analyze</h5>
                <p>
                  Identify various areas of improvement and pain points to
                  understand how we can help you.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="Our_Process">
                <div class="why-icon">
                  <img src={number_2} alt="" className="img-fliud" />
                </div>
                <h5>Model</h5>
                <p>
                  Strategize tools and resources from the right partners to give
                  you a model that is cost-effective and effecient.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="why-icon">
                <img src={number_3} alt="" className="img-fliud" />
              </div>
              <h5>Execute and Deliver</h5>
              <p>
                Deliver and train your IT and support team to sustain. Also
                adjust the processes to improve business objective.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default Deployment_Management;
